import React from 'react';

const Spinner = ({ size = 'md', className = '' }) => {
  const sizeClass = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-4',
    lg: 'w-12 h-12 border-4',
  }[size];

  return (
    <div
      className={`${sizeClass} border-gray-900 border-t-transparent rounded-full animate-spin ${className}`}
      role="status"
      aria-label="Carregando"
    />
  );
};

export const FullPageSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <Spinner size="lg" />
  </div>
);

export default Spinner;
